function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 470,
  height: 145,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M393.88 3C401.126 3 407 8.104 407 14.4s-5.874 11.4-13.12 11.4h-74.97c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4h41.234c7.246 0 13.119 5.104 13.119 11.4s-5.873 11.4-13.119 11.4h-19.069c-9.136 0-16.542 5.104-16.542 11.4q0 6.295 11.245 11.4c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4H180.216c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4H107.12C99.874 94.2 94 89.096 94 82.8s5.874-11.4 13.12-11.4h74.97c7.246 0 13.12-5.104 13.12-11.4s-5.874-11.4-13.12-11.4h-46.856c-7.246 0-13.12-5.104-13.12-11.4s5.874-11.4 13.12-11.4h74.97c-7.246 0-13.12-5.104-13.12-11.4S202.958 3 210.204 3zm0 45.6c7.246 0 13.12 5.104 13.12 11.4s-5.874 11.4-13.12 11.4-13.12-5.104-13.12-11.4 5.874-11.4 13.12-11.4",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M440.403 27h-13.865m24.591-23H422zM463 4h-3.767zM160 141h-16.917m7.242-26h-35.539zm-47.591 0H94z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "M284.492 84.001h-46.493a1.595 1.595 0 0 1-1.275-2.55l1.275-1.699V52.126c0-4.24 1.033-8.236 2.866-11.752l-11.176-11.172 4.511-4.51 63.109 63.112-4.51 4.507zm-38.817-38.817a19.1 19.1 0 0 0-1.301 6.942v25.5h33.743zm43.324 25.385-6.375-6.375V52.126a19.124 19.124 0 0 0-28.655-16.584l-4.622-4.629a25.497 25.497 0 0 1 36.027 8.107 25.5 25.5 0 0 1 3.625 13.106zm-33.468 16.62h15.937a7.97 7.97 0 0 1-7.969 7.969 7.967 7.967 0 0 1-7.968-7.97",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgNotification as ReactComponent };
export default __webpack_public_path__ + "78ed4c82cd8c7c1b8be6e3f46ec3ccfa.svg";